import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

// import 'react-tabs/style/react-tabs.css'

import logo from '@/assets/images/logo.png'
import { isNullorEmpty, isNullorEmptyArr } from '@/utils'

import AestheticModelPDF from './pdfComponents/AestheticModelPDF'
import DentinLayerAdvice from './pdfComponents/DentinLayer'
import DentinPDF from './pdfComponents/DentinPDF'
import FrameworkPDF from './pdfComponents/FrameworkPDF'
import Inputs from './pdfComponents/Inputs'
import MaskingPDF from './pdfComponents/MaskingPDF'
import OpaquerPDF from './pdfComponents/OpaquerPDF'
import SkinEnamelPDF from './pdfComponents/SkinEnamelPDF'

type RecipeOutputPDFEntity = {
  recipe: any
  frameworkIndex: number
  dentinCervicalIndex: number
  dentinMiddleIndex: number
  dentinIncisalIndex: number
  id: string
}

const RecipeOutputPDF = (props: RecipeOutputPDFEntity) => {
  const {
    recipe,
    frameworkIndex,
    dentinCervicalIndex,
    dentinMiddleIndex,
    dentinIncisalIndex,
  } = props
  const [dentin, setDentin] = useState<boolean>(false)
  //   const caseDetail = useSelector((state) => state.case)
  //   const subscribedFeatures = useSelector(
  //     (state) => state.profile.subscribed_features,
  //   )
  //   const isAccessible = (key: string) =>
  //     subscribedFeatures?.includes(Features[key as keyof typeof Features])
  const conditionalRenderDentin = () => {
    if (
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_cervical', 'type_layer1'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_cervical',
          'recipe_layer1',
          `${dentinCervicalIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_cervical',
          'recipe_layer1',
          `${dentinCervicalIndex}`,
          'simplified_ratios',
        ],
      ) &&
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_cervical', 'type_layer2'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_cervical',
          'recipe_layer2',
          `${dentinCervicalIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_cervical',
          'recipe_layer2',
          `${dentinCervicalIndex}`,
          'simplified_ratios',
        ],
      )
    ) {
      setDentin(true)
    }

    if (
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_middle', 'type_layer1'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_middle',
          'recipe_layer1',
          `${dentinMiddleIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_middle',
          'recipe_layer1',
          `${dentinMiddleIndex}`,
          'simplified_ratios',
        ],
      ) &&
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_middle', 'type_layer2'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_middle',
          'recipe_layer2',
          `${dentinMiddleIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_middle',
          'recipe_layer2',
          `${dentinMiddleIndex}`,
          'simplified_ratios',
        ],
      )
    ) {
      setDentin(true)
    }

    if (
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_incisal', 'type_layer1'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_incisal',
          'recipe_layer1',
          `${dentinIncisalIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_incisal',
          'recipe_layer1',
          `${dentinIncisalIndex}`,
          'simplified_ratios',
        ],
      ) &&
      isNullorEmptyArr(
        [recipe.dentinlayer_advice, 'dentinrecipes_incisal', 'type_layer2'],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_incisal',
          'recipe_layer2',
          `${dentinIncisalIndex}`,
          'powders',
        ],
        [
          recipe.dentinlayer_advice,
          'dentinrecipes_incisal',
          'recipe_layer2',
          `${dentinIncisalIndex}`,
          'simplified_ratios',
        ],
      )
    ) {
      setDentin(true)
    }
  }

  useEffect(() => {
    conditionalRenderDentin()
  }, [dentinCervicalIndex, dentinMiddleIndex, dentinIncisalIndex])

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          fontSize: '20px',
          zIndex: -1000,
        }}
        className="save-image"
      >
        <div
          className="d-flex flex-column download-pdf"
          style={{ paddingBottom: '200px' }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexGrow={1}
            p={5}
            sx={{ backgroundColor: '#FFF', color: 'black', height: '100%' }}
          >
            {/* Left Section (Logo) */}
            <Box>
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 200, height: 55, color: 'black' }}
              />
            </Box>

            {/* Center Section (Title) */}
            <Typography variant="h1" sx={{ m: 0, fontSize: '3rem' }}>
              Recipe
            </Typography>

            {/* Right Section (Indication) */}
            <Box sx={{ width: '20%' }}>
              <Box display="flex" alignItems="center" m={2}>
                <Typography sx={{ m: 0, fontSize: '18px' }}>
                  Indication:
                </Typography>
                {isNullorEmpty(recipe?.provided_input, 'indication') && (
                  <Box
                    sx={{
                      ml: 2,
                      p: 1,
                      backgroundColor: '#F44336',
                      color: 'black',
                      borderRadius: '16px',
                      fontSize: '18px',
                    }}
                  >
                    {recipe.provided_input.indication}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            flexGrow={1}
            color="black"
            sx={{
              pl: 6,
              pt: 2,
              fontWeight: 'bold',
              fontSize: '1.5rem',
              height: '100%',
            }}
          >
            {/* Dentist */}
            <Box>
              <Typography sx={{ m: 0, p: 0 }}>
                Dentist:{' '}
                <Typography
                  component="span"
                  sx={{ fontWeight: 'normal' }}
                ></Typography>
              </Typography>
            </Box>

            {/* Patient */}
            <Box>
              <Typography sx={{ m: 0, p: 0 }}>
                Patient:{' '}
                <Typography
                  component="span"
                  sx={{ fontWeight: 'normal' }}
                ></Typography>
              </Typography>
            </Box>
          </Box>

          <Inputs recipe={recipe} />

          <AestheticModelPDF recipe={recipe} />

          <FrameworkPDF recipe={recipe} frameworkIndex={frameworkIndex} />

          <OpaquerPDF recipe={recipe} />

          <MaskingPDF recipe={recipe} />

          <SkinEnamelPDF recipe={recipe} />

          {dentin && (
            <DentinPDF
              recipe={recipe}
              dentinCervicalIndex={dentinCervicalIndex}
              dentinMiddleIndex={dentinMiddleIndex}
              dentinIncisalIndex={dentinIncisalIndex}
            />
          )}
          {!dentin && (
            <DentinLayerAdvice
              recipe={recipe}
              dentinCervicalIndex={dentinCervicalIndex}
              dentinMiddleIndex={dentinMiddleIndex}
              dentinIncisalIndex={dentinIncisalIndex}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default RecipeOutputPDF
